import { useEffect } from 'react';

import { useRecipeEditor } from '../context/RecipeEditorContext';
import { getRecipeEditorEventBus } from '../events/recipeEditorEvents';

/**
 * Hook that listens to recipe editor events and updates context state
 * This creates a clean separation between event emission (child components)
 * and state management (parent context)
 */
export const useRecipeEditorEvents = () => {
  const { dispatch } = useRecipeEditor();

  useEffect(() => {
    const eventBus = getRecipeEditorEventBus();

    // Listen for recipe modified events
    const handleRecipeModified = () => {
      dispatch({ type: 'SET_IS_MODIFIED', payload: true });
    };

    // Listen for recipe saved events
    const handleRecipeSaved = () => {
      dispatch({ type: 'SET_IS_MODIFIED', payload: false });
    };

    // Listen for recipe loaded events
    const handleRecipeLoaded = () => {
      dispatch({ type: 'SET_IS_MODIFIED', payload: false });
    };

    // Subscribe to events
    eventBus.on('recipe:modified', handleRecipeModified);
    eventBus.on('recipe:saved', handleRecipeSaved);
    eventBus.on('recipe:loaded', handleRecipeLoaded);

    // Cleanup on unmount
    return () => {
      eventBus.off('recipe:modified', handleRecipeModified);
      eventBus.off('recipe:saved', handleRecipeSaved);
      eventBus.off('recipe:loaded', handleRecipeLoaded);
    };
  }, [dispatch]);
};
